import {GenericService, ResultType} from '@/shared/xhttp';
import {Achat, BoisType, EssenceAchat, LongueursAchat} from '@/models';

export class EssenceAchatService extends GenericService<EssenceAchat> {

	public getTotauxEssenceAchats(totalParBoisType: boolean, totalParLongueur: boolean): Promise<ResultType<EssenceAchat>> {
		return super.getC(`/totaux-essence-achats/${totalParBoisType ? 1 : 0 }/${totalParLongueur ? 1 : 0 }`, 10000);
	}

	public getRechercheEssenceAchats(boisType: BoisType, longueur: LongueursAchat, localisation: string): Promise<ResultType<EssenceAchat>> {
		return super.getC(`/recherche-essence-achats/${boisType ? boisType.id : 0}/${longueur ? longueur.id : 0}${localisation ? '/' + localisation : ''}`, 10000);
	}

	public async putFinCoupe(essenceAchat: EssenceAchat) {
		return await this.put(`/${essenceAchat.id}/fin-coupe`);
	}
}